import { loadableWithFallback } from '@vision/ui/utils';
import type { GeoChart1Props } from './GeoChart1';

export const GeoChart1 = loadableWithFallback<GeoChart1Props>(() => import('./GeoChart1'));
